// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import Checkmark from '../_raw/ui/icon_checkmark.svg';
import withIconProps from '../withIconProps';

export default withIconProps(Checkmark);
